import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';



import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';



const headCells = [
   { id: 'followupdate', numeric: false, label: 'Followup Date' },  
    { id: 'Type', numeric: false, label: 'Type' },
	
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Leadstatus extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Leadstatusdata:[],lsid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',type:'',fromdate:'',todate:''     
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Leadstatusdata:[]
    });
	
 
}
	componentDidMount  () {	
	
	
	document.title = "AthaYog Living - Lead Status";
	
	/*if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }*/
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}

 handleClickSearch=()=>{    
  this.apicall(this.state.page,this.state.rowsPerPage);	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxleadmaster.php?action=statusgetall&fromdate='+this.state.fromdate+'&todate='+this.state.todate+'&ls_type='+this.state.type+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Leadstatusdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({Leadstatusdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{setTimeout(() =>  this.componentDidUpdate() ,500); });
   
 
    
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      LeadstatusDelete(lsid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','statusdelete')
	 formData.append('ls_id',lsid)
	 	   
	formData.append('userid',1)
	
	
	 axios.post(Serverurl+"ajaxleadmaster.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }
      Leadaddbox(val){
        this.setState({ lsid: val });  
  
         setTimeout(() => this.refs.AddLeadbox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   
<div className="contentmain">
<div className="boxheading">
				  <div className="contntpad">
<h2>Lead Status</h2>
</div></div>

   <div className="searchmaster">


  
  <ul>
  
 <li>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.fromdate}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="From Date"
            name="fromdate" onChange={this.myChangeHandler}
		
          /></p></li>
		  <li>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.todate}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="To Date"
            name="todate" onChange={this.myChangeHandler}
		
          /></p></li>
		
		
	<li>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.type}
		  name="type"
		
        >
	
	<option value="">Select Type</option>
          <option value={1}>Interested</option>
          <option value={2}>Not Interested</option> 
 <option value={3}>Followup Date</option>

        </Select>

		</FormControl>
		</p>
	</li>		
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.Leadaddbox(0)}} className="frmPrimarybtn" endIcon={<AddIcon />}>
        New
      </Button></p></li> 
		
		
		
		
		</ul>
		
</div>		



<AddLeadbox ref="AddLeadbox" id={this.state.lsid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Leadstatusdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Leadstatusdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.followupdate}</TableCell>
<TableCell>{item.type}</TableCell>

<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Leadaddbox(item.ls_id)}} endIcon={<EditIcon />}>
Edit
</Button>&nbsp;&nbsp;


<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.LeadstatusDelete(item.ls_id)}} endIcon={<DeleteIcon />} >
  Delete
</Button>

 


 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
       
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    
</div>
 </React.Fragment> 

 
 
  );
}
}


export  class  AddLeadbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,name:'',ls_id:0,type:'',comments:'',followupdate:'',errormessage:'',erropen:false,btndisabled:false,
submitbtn:"Save"
	  }
      
  }
  
 

  
 Leadmastergetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxleadmaster.php?action=statusgetall&ls_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      ls_id:resp.data[0].ls_id,	    
type: resp.data[0].ls_type, 
comments: resp.data[0].ls_comments, 
followupdate: resp.data[0].followupdate,    
    
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  
	 ls_id:0,
	 type:'',
	 comments:'',
	 followupdate:''
	 
	  }); 
 }

  
    }

   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,errormessage:'',erropen:false,ls_id:0,type:'',comments:'',followupdate:''	  });
		this.Leadmastergetdata();
		
};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  
  
  this.setState({[nam]: val});
 
  

}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	
	
 let followupdate = this.state.followupdate;
  let type = this.state.type;
  let comments = this.state.comments;
    

if(followupdate==="")
{
	
	this.setState({errormessage:"Please Enter Follow Up Date.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(type==="")
{
	
	this.setState({errormessage:"Please Select Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  
  
   if(this.state.ls_id==0)
	  {
		  formData.append('ls_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('ls_id',this.state.ls_id)
		
      }
		formData.append('action','statusinsert') 
		formData.append('ls_followupdate',followupdate)	
		formData.append('ls_type',type)
		formData.append('ls_comments',comments)			
		formData.append('userid',1)		  
		axios.post(Serverurl+"ajaxleadmaster.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save",  });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Lead Status</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		<p> <span className="validation">*</span>Followup Date</p>
	
	<p><TextField name="followupdate" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.followupdate}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:13}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>		
						  
						  
		

		
						  
		<p> <span className="validation">*</span>Type</p>				  
						  <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.type}
		  name="type"
		
        >
	
	<option value="">Select Type</option>
          <option value={1}>Interested</option>
          <option value={2}>Not Interested</option> 
 <option value={3}>Followup Date</option>

        </Select>

		</FormControl>
		</p>
		
<p>Comments: </p>
		  
		   <p> 
		  
	 <TextField name="comments" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.comments}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "10",maxLength:400}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>	
		
       <div className="actionbtns">
	   <div className="cancelbtn">	  
	   <Button variant="contained" className="frmSecondarybtn" onClick={this.handleClickOpen}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmPrimarybtn" onClick={this.handleClose}>
   {this.state.submitbtn}
</Button>
  </div>     


	
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  